export default __webpack_public_path__ + "static/media/image_bh_visit_graphic_break_screen.9c6f367e.svg";